// services/api/tutorService.js
import API from '../api/api';

export const sessionService = {
  
  endSession: async (session_id) => {
    const payload = { session_id: session_id }
    const response = await API.post('/end_session', payload);
    return response.data;
  },

  checkValidSession: async (session_id) => {
    const response = await API.get('/valid_session', {params: { session_id }});
    return response.completed;
  },
};


